/**
 * Application-wide constants
 */

export const APP_NAME = 'Alpha Crypto Trading Suite';
export const APP_VERSION = '0.1.0';

/**
 * Storage keys for localStorage
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
  CHART_TIMEFRAME: 'chart_timeframe',
} as const;

/**
 * API response status codes
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/**
 * WebSocket events
 */
export const WS_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  ERROR: 'error',
  MESSAGE: 'message',
  TICKER: 'ticker',
  ORDER: 'order',
  PORTFOLIO: 'portfolio',
  TRADE: 'trade',
} as const;

/**
 * Chart settings
 */
export const CHART_DEFAULTS = {
  // Keep every interval offered by the token-chart toolbar here so a selection
  // can be restored when the page remounts. The toolbar includes `1s`, which
  // was previously saved but then rejected on the next token as unknown.
  TIMEFRAMES: ['1s', '1m', '5m', '15m', '1h', '4h', '1d'] as const,
  DEFAULT_TIMEFRAME: '15m',
  COLORS: {
    BULLISH: '#10b981',
    BEARISH: '#ef4444',
    BACKGROUND: '#1a1a1a',
    GRID: '#2a2a2a',
  },
} as const;

/**
 * Trading constants
 */
export const TRADING = {
  ORDER_TYPES: ['market', 'limit', 'stop_limit'] as const,
  ORDER_SIDES: ['buy', 'sell'] as const,
  ORDER_STATUSES: ['pending', 'filled', 'cancelled', 'rejected'] as const,
  MIN_ORDER_SIZE: 0.0001,
  MAX_ORDER_SIZE: 1000000,
} as const;

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

/**
 * Debounce/Throttle delays (ms)
 */
export const DELAYS = {
  SEARCH_DEBOUNCE: 500,
  WEBSOCKET_THROTTLE: 100,
  RESIZE_DEBOUNCE: 300,
} as const;

/**
 * Date/Time formats
 */
export const DATE_FORMATS = {
  SHORT: 'MMM d, yyyy',
  LONG: 'MMMM d, yyyy',
  WITH_TIME: 'MMM d, yyyy HH:mm',
  FULL: 'MMM d, yyyy HH:mm:ss',
  TIME_ONLY: 'HH:mm:ss',
} as const;
